import { render, staticRenderFns } from "./SourceOfCurationTooltip.vue?vue&type=template&id=0c50815d"
import script from "./SourceOfCurationTooltip.vue?vue&type=script&lang=js"
export * from "./SourceOfCurationTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports